import { Base } from "ui/Scripts/source/framework/base";
import { ApplicationPermission, IApplicationPermission } from "../common/applicationPermission";
import { CodeTitle, ICodeTitle } from "../common/codeTitle";
import { CompanyGroupListItem, ICompanyGroupListItem } from "../companyGroup/companyGroupListItem";
import { IUserExternalSystem, UserExternalSystem } from "../externalSystem/userExternalSystem";
import { FileFilterListItem, IFileFilterListItem } from "../fileFilter/fileFilterListItem";
import { CompanyIntraModule, ICompanyIntraModule } from "../intraModule/companyIntraModule";
import { IMessageTypeListItem, MessageTypeListItem } from "../messageType/messageTypeListItem";
import { IUnitModuleNode, UnitModuleNode } from "../unit/unitModuleNode";
import { CompanyEditItem, ICompanyEditItem } from "./companyEditItem";
import { CompanyListItem, ICompanyListItem } from "./companyListItem";

export interface ICompanyEdit {
    company: ICompanyEditItem;
    unitModuleNode: IUnitModuleNode;
    defaultLogo: string;
    defaultLogoInUse: boolean;
    usedFileStorageQuota: number;
    companyGroupsEnabled: boolean;
    partnerCompaniesEnabled: boolean;
    allPartnersCompanyGroupId: string;
    canEditWhistleBlowSettings: boolean;
    customStyles: ICodeTitle[];
    applicationPermissions: IApplicationPermission[];
    externalSystems: IUserExternalSystem[];
    intraModules: ICompanyIntraModule[];
    companyGroups: ICompanyGroupListItem[];
    partnerCompanies: ICompanyListItem[];
    fileFilters: IFileFilterListItem[];
    messageTypes: IMessageTypeListItem[];
}

export class CompanyEdit implements ICompanyEdit {
    company: CompanyEditItem;
    unitModuleNode: UnitModuleNode;
    defaultLogo: string;
    defaultLogoInUse: boolean;
    usedFileStorageQuota: number;
    companyGroupsEnabled: boolean;
    partnerCompaniesEnabled: boolean;
    allPartnersCompanyGroupId: string;
    canEditWhistleBlowSettings: boolean;
    customStyles: CodeTitle[];
    applicationPermissions: ApplicationPermission[];
    externalSystems: UserExternalSystem[];
    intraModules: CompanyIntraModule[];
    companyGroups: CompanyGroupListItem[];
    partnerCompanies: CompanyListItem[];
    fileFilters: FileFilterListItem[];
    messageTypes: MessageTypeListItem[];

    constructor();
    constructor(obj: ICompanyEdit);
    constructor(obj?: any) {
        this.company = new CompanyEditItem(obj ? obj.company : null);
        this.unitModuleNode = new UnitModuleNode(obj ? obj.unitModuleNode : null);
        this.defaultLogo = obj && obj.defaultLogo || "";
        this.defaultLogoInUse = obj && obj.defaultLogoInUse || false;
        this.usedFileStorageQuota = obj && obj.usedFileStorageQuota || 0;
        this.companyGroupsEnabled = obj && obj.companyGroupsEnabled || false;
        this.partnerCompaniesEnabled = obj && obj.partnerCompaniesEnabled || false;
        this.allPartnersCompanyGroupId = obj && obj.allPartnersCompanyGroupId || "";
        this.canEditWhistleBlowSettings = obj && obj.canEditWhistleBlowSettings || false;
        this.customStyles = Base.getTypedArray(obj ? obj.customStyles : null, CodeTitle);
        this.applicationPermissions = Base.getTypedArray(obj ? obj.applicationPermissions : null, ApplicationPermission);
        this.externalSystems = Base.getTypedArray(obj ? obj.externalSystems : null, UserExternalSystem);
        this.intraModules = Base.getTypedArray(obj ? obj.intraModules : null, CompanyIntraModule);
        this.companyGroups = Base.getTypedArray(obj ? obj.companyGroups : null, CompanyGroupListItem);
        this.partnerCompanies = Base.getTypedArray(obj ? obj.partnerCompanies : null, CompanyListItem);
        this.fileFilters = Base.getTypedArray(obj ? obj.fileFilters : null, FileFilterListItem);
        this.messageTypes = Base.getTypedArray(obj ? obj.messageTypes : null, MessageTypeListItem);
    }
}